import BlogsComponent from '../components/blogs/blogs'

const Blogs = () => <BlogsComponent />

export default Blogs;